/**
 * Font size for a label drawn inside a floor-plan rectangle, in plan units.
 *
 * SVG text does not wrap or clip, so a long name in a narrow box ("Washroom"
 * in a 6-unit stall) runs past its edges. The size is capped by height and
 * by the width the text needs; average glyph advance is ~0.6 em for the UI
 * sans faces. Returns `null` when the fitted text would be too small to read,
 * so callers drop the label and keep the `<title>` tooltip.
 */
export function fitFloorLabelSize(
  label: string,
  width: number,
  height: number,
  { max = 4, min = 1.8 }: { max?: number; min?: number } = {},
): number | null {
  const chars = Math.max(1, label.trim().length);
  const byWidth = (width * 0.86) / (chars * 0.6);
  const size = Math.min(max, height * 0.6, byWidth);
  return size >= min ? size : null;
}
